// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_root_cause_enum */
var FermentationRootCauseEnum;
(function (FermentationRootCauseEnum) {
    FermentationRootCauseEnum["CONTAMINATION"] = "CONTAMINATION";
    FermentationRootCauseEnum["EQUIPMENT_FAILURE"] = "EQUIPMENT_FAILURE";
    FermentationRootCauseEnum["OPERATOR_ERROR"] = "OPERATOR_ERROR";
    FermentationRootCauseEnum["MEDIUM_OR_FEED"] = "MEDIUM_OR_FEED";
    FermentationRootCauseEnum["PROCESS_CONTROL"] = "PROCESS_CONTROL";
    FermentationRootCauseEnum["SEED_TRAIN"] = "SEED_TRAIN";
    FermentationRootCauseEnum["UNKNOWN"] = "UNKNOWN";
    FermentationRootCauseEnum["OTHER"] = "OTHER";
})(FermentationRootCauseEnum || (FermentationRootCauseEnum = {}));
;
export default FermentationRootCauseEnum;
/** Zod schema for fermentation_root_cause_enum */
export const fermentationRootCauseEnum = z.nativeEnum(FermentationRootCauseEnum);
//# sourceMappingURL=FermentationRootCauseEnum.js.map